import type React from 'react';

import '@change/ds-core-ui/styles.css';
import '@change/ds-forms/styles.css';
import '@change/ds-icons/styles.css';
import '@change/ds-layout/styles.css';
import '@change/ds-maps/styles.css';
import './index.css';

// TODO remove those styles and make sure this does not break UI
// that was relying on those styles being set
const TEMPORARY_OLD_DS_GLOBAL_STYLES = `
/*
	Default typography
*/
body {
	font-size: 16px;
	line-height: 1.5;
}

/*
	Default button styles
*/
button {
	padding: 0;
	background: none;
	border: 0;
}

button:focus-visible {
	outline-color: #2684ff;
	outline-offset: 1px;
}

/*
	Box model
*/
*,
*::before,
*::after {
	box-sizing: border-box;
}

/*
	Default list styles
*/
ol,
ul {
	margin: 0;
	padding: 0;
	list-style-type: none;
}

/*
	Default anchor styles
*/
a {
	color: inherit;
	cursor: pointer;
	text-decoration: underline;

	&:active {
		outline: none;
	}
}

a:focus-visible {
	outline-color: #2684ff;
	outline-offset: 1px;
}

/*
	Paragraphs

	Normalize margins for paragraphs. This allows you to use the <p> tag
	freely without having to apply spacing overrides for margin.
*/
p {
	margin: 0;
}
`;

// Global CSS reset/base styles (no Tailwind hook available, and we no longer use emotion/theme-ui).
// Injected via a plain <style> element.
const STYLES = `
@layer base {
	body {
		padding: 0;
		margin: 0;
		font-family: 'Commissioner', 'Helvetica Neue', Helvetica, Arial, Tahoma, sans-serif;
	}

	/* css-only inert polyfill */
	/* https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/inert */
	/* add https://github.com/WICG/inert full polyfill for the Element.inert support */
	[inert],
	[inert] * {
		user-select: none;
	}
	[inert] {
		pointer-events: none;
		cursor: default;
	}

	/* FIXME temporary fix to hide outline caused when navigating */
	/* from the DS header */
	/* TODO investigate why this happens */
	[data-maincontent]:focus,
	[data-maincontent-principal]:focus {
		outline: none;
	}

	${TEMPORARY_OLD_DS_GLOBAL_STYLES}
}
`;

export const AppGlobalStyle: React.FC = () => {
	// eslint-disable-next-line react/no-danger
	return <style dangerouslySetInnerHTML={{ __html: STYLES }} />;
};
